import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GisMapComponent } from '../gis-map/gis-map.component';
import { DxFormModule, DxNumberBoxModule } from 'devextreme-angular';
import { CtlGenKontrolComponent } from '../controls/ctl-gen-kontrol/ctl-gen-kontrol.component';
import { LabelMode } from 'devextreme/common';
import { DkGlobalUserSettingsService } from '../../services/dk-global-user-settings.service';
import { LabelLocation } from 'devextreme/ui/form';
import { ValueChangedEvent as NumberBoxValueChanged } from 'devextreme/ui/number_box';
import { ValueChangedEvent as TextBoxValueChanged } from 'devextreme/ui/text_box';
import { DxButtonTypes } from 'devextreme-angular/ui/button';
import { DkFormPopupComponent } from '../components';
import { GisAdresService } from '../../services/gis/gis-adres.service';
import { GisEntityName } from '../../services/gis/gis.models';

@Component({
  selector: 'dk-gen-adres-harita',
  standalone: true,
  imports: [
    CommonModule,
    GisMapComponent,
    DxFormModule,
    CtlGenKontrolComponent,
    DxNumberBoxModule,
    DkFormPopupComponent
  ],
  templateUrl: './gen-adres-harita.component.html',
  styleUrls: ['./gen-adres-harita.component.scss'],
})
export class GenAdresHaritaComponent {
  @Input() adresKontrolTuru: string; // Parametre tablolarından okunur

  @Input() showParselKod: boolean = true;
  @Input() showAda: boolean = true;
  @Input() showParsel: boolean = true;
  @Input() showPafta: boolean = true;
  @Input() showBinaKod: boolean = true;

  @Input() parselKod: number;
  @Input() ada: number;
  @Input() parsel: number;
  @Input() pafta: string;
  @Input() binaKod: number;

  @Output() parselKodChange = new EventEmitter<number>();
  @Output() adaChange = new EventEmitter<number>();
  @Output() parselChange = new EventEmitter<number>();
  @Output() paftaChange = new EventEmitter<string>();
  @Output() binaKodChange = new EventEmitter<number>();
  @Input() labelMode: LabelMode = this.globalSettings.globalLabelMode;
  @Input() labelLocation: LabelLocation =
    this.globalSettings.globalLabelLocation;
  @Input() readOnly: boolean = false;

  @Input() parselKodValidationRules: any[] = [];

  mapText: GisEntityName;
  mapValue: number;
  showMapPopup: boolean = false;

  mapParselButtonOptions: DxButtonTypes.Properties = {
    icon: 'map',
    stylingMode: 'contained',
    type: 'default',
    onClick: () => {
      this.showMap('PARSEL');
    },
    disabled: false,
  };

  mapBinaKodButtonOptions: DxButtonTypes.Properties = {
    icon: 'map',
    stylingMode: 'contained',
    type: 'default',
    onClick: () => {
      this.showMap('BINA');
    },
    disabled: false,
  };

  constructor(private globalSettings: DkGlobalUserSettingsService,
              private gisAdresService: GisAdresService) {}



  parselKodControlResult(e:any){
    this.parselKod = e?.Kod;
    this.parselKodChange.emit(this.parselKod);
    this.ada = e?.Ada;
    this.adaChange.emit(this.ada);
    this.parsel = e?.Parsel;
    this.parselChange.emit(this.parsel);
    this.pafta = e?.Pafta;
    this.paftaChange.emit(this.pafta);
  }

  onAdaValueChanged = ($event: NumberBoxValueChanged) => {
    this.ada = $event.value;
    this.adaChange.emit(this.ada);
  };

  onPaftaValueChanged = ($event: TextBoxValueChanged) => {
    this.pafta = $event.value;
    this.paftaChange.emit(this.pafta);
  };

  onParselValueChanged = ($event: NumberBoxValueChanged) => {
    this.parsel = $event.value;
    this.parselChange.emit(this.parsel);
  };

  onParselKodValueChanged = ($event: NumberBoxValueChanged) => {
    this.parselKod = $event.value;
    this.parselKodChange.emit(this.parselKod);
  };

  onBinaKodValueChanged = ($event: NumberBoxValueChanged) => {
    this.binaKod = $event.value;
    this.binaKodChange.emit(this.binaKod);
  };



  async showMap(tur: 'PARSEL' | 'BINA') {
    const hedef = await this.gisAdresService.hedefBul(tur, { parselKod: this.parselKod, binaKod: this.binaKod });
    if (!hedef) return;
    this.mapText = hedef.entityName;
    this.mapValue = hedef.entityId;
    this.showMapPopup = true;
  }

}
